import { render, staticRenderFns } from "./ProductSelecter.vue?vue&type=template&id=8f706b78"
import script from "./ProductSelecter.vue?vue&type=script&lang=js"
export * from "./ProductSelecter.vue?vue&type=script&lang=js"
import style0 from "./ProductSelecter.vue?vue&type=style&index=0&id=8f706b78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports